import { MdChevronLeft } from 'react-icons/md';
import { Button, Divider, IconButton, ModalBody, ModalFooter, ModalHeader } from '@ds';
import { CaseNoteCard } from '@lp/features/CaseNoteCard';
import { useCaseNotesStore } from '@/store/case-notes.store';
import { CaseNote } from '@/api/apis/case';
import { useDeleteCaseNoteMutation } from '@/queries/case';

export const RemoveNoteModalContent = ({ caseId }: { caseId: string }) => {
  const { isPending, mutateAsync: submitCaseNoteDelete } = useDeleteCaseNoteMutation();
  const setRemoveNote = useCaseNotesStore.use.setRemoveNote();
  const note = useCaseNotesStore.use.removeNote() as CaseNote;

  const closeRemoveNote = () => setRemoveNote(null);

  const onDeleteSubmit = async () => {
    await submitCaseNoteDelete({ caseId, noteId: note.noteId });
    closeRemoveNote();
  };

  return (
    <>
      <ModalHeader>
        <div className="flex flex-col gap-2">
          <div className="flex items-center">
            <IconButton size="xs" variant="outline" startContent={<MdChevronLeft />} onPress={closeRemoveNote} />
            <h3 className="ml-3">Delete Note</h3>
          </div>
          <span className="text-base-20 text-l-r ml-9">Are you sure you want to delete the Case Note?</span>
        </div>
      </ModalHeader>
      <div className="px-6">
        <Divider />
      </div>
      <ModalBody className="flex-none py-6">
        <CaseNoteCard caseId={caseId} data={note} readonly />
      </ModalBody>
      <div className="px-6">
        <Divider />
      </div>
      <ModalFooter>
        <div className="flex gap-3">
          <Button variant="outline" onPress={closeRemoveNote} className="flex-1">
            Discard
          </Button>
          <Button
            variant="solid"
            color="danger"
            isLoading={isPending}
            onPress={onDeleteSubmit}
            className="flex-1 text-base-90"
          >
            Delete Note
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};
